import { cancelOptionRfs } from '@/api/option/cancelOptionRfs.ts';
import { executeOption } from '@/api/option/executeOption.ts';
import { requestOptionRfs } from '@/api/option/requestOptionRfs.ts';
import { updateOptionRfs } from '@/api/option/updateOptionRfs.ts';
import { webapi } from '@/api/webapi.ts';

export const optionApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    requestOptionRfs: requestOptionRfs(builder),
    executeOptionRfs: executeOption(builder),
    cancelOptionRfs: cancelOptionRfs(builder),
    updateOptionRfs: updateOptionRfs(builder),
  }),
});

export const {
  useCancelOptionRfsMutation,
  // useExecuteOptionRfsMutation,
  useRequestOptionRfsMutation,
  // useUpdateOptionRfsMutation
} = optionApi;
